import * as React from "react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";

interface Props {
  content: React.ReactNode;
  // Omit all three to render a page without a sidebar (e.g. a pop-out viewer).
  navigation?: React.ReactNode;
  navigationOpen?: boolean;
  onNavigationChange?: (open: boolean) => void;
}

const PageShell: React.FC<Props> = ({ navigation, content, navigationOpen, onNavigationChange }) => (
  <AppLayout
    headerSelector="#apaq-top-nav"
    navigationHide={navigation === undefined}
    navigationOpen={navigationOpen}
    onNavigationChange={({ detail }) => onNavigationChange?.(detail.open)}
    navigation={navigation}
    content={content}
    toolsHide={true}
    contentType="default"
  />
);

export default PageShell;
